import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip as ChartTooltip } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { formatAed } from '../../utils/format';
import type { ApplicationRecord } from '../../types/domain';
const palette = ['var(--chart-1)', 'var(--chart-3)', 'var(--chart-2)', 'var(--chart-7)', 'var(--chart-6)', 'var(--chart-4)', 'var(--chart-5)'];
export function SupportBySector({
  records
}: {
  records: ApplicationRecord[];
}) {
  const sectors = Array.from(new Set(records.map(record => record.sector)));
  const data = sectors.map(sector => ({
    sector,
    aed: records.filter(record => record.sector === sector).reduce((sum, record) => sum + record.requestedSupportAed, 0)
  })).sort((a, b) => b.aed - a.aed);
  const total = data.reduce((sum, row) => sum + row.aed, 0);
  return <SectionCard title="Support requested by sector" description="Distribution of the AED envelope across sectors in the live portfolio" data-id="element-486" data-mp="3oyu4echxj6xt">
      <div className="grid gap-4 sm:grid-cols-[180px_1fr] sm:items-center" data-id="element-487" data-mp="27vlae2n1gqkn">
        <div className="h-44" data-id="element-488" data-mp="23v17sjjp4ur4">
          <ResponsiveContainer width="100%" height="100%" data-id="element-489" data-mp="23rwyj7rdj8tl">
            <PieChart data-id="element-490" data-mp="2hlwnofsm4c47">
              <Pie data={data} dataKey="aed" nameKey="sector" innerRadius={38} outerRadius={68} paddingAngle={1} stroke="var(--card)" data-id="element-491" data-mp="2hmfup1gq5g3g">
                {data.map((entry, index) => <Cell key={entry.sector} fill={palette[index % palette.length]} data-id="element-492" data-mp="2mmc1t9kpxnn8" data-mpi={index} />)}
              </Pie>
              <ChartTooltip contentStyle={{
              fontSize: 12,
              borderRadius: 4,
              border: '1px solid var(--border)'
            }} formatter={(value: number) => formatAed(value)} data-id="element-493" data-mp="2vl5r0evpzbqr" />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <ul className="space-y-1.5" data-id="element-494" data-mp="118zhrlmdz513">
          {data.map((row, index) => <li key={row.sector} className="flex items-center justify-between gap-3" data-id="element-495" data-mp="31ap91qbukf4y" data-mpi={index}>
              <span className="flex min-w-0 items-center gap-2 text-[12px]" data-id="element-496" data-mp="3690gjueo6dk0">
                <span className="h-2.5 w-2.5 shrink-0 rounded-sm" style={{
              background: palette[index % palette.length]
            }} aria-hidden="true" data-id="element-497" data-mp="3b72bpdpde3bu" />
                <span className="truncate" data-id="element-498" data-mp="3k6yw334q8g13">{row.sector}</span>
              </span>
              <span className="shrink-0 font-mono text-[11px] text-muted-foreground" data-id="element-499" data-mp="3p6jwlhzjowfx">
                {formatAed(row.aed)} · {Math.round(row.aed / total * 100)}%
              </span>
            </li>)}
        </ul>
      </div>
    </SectionCard>;
}